var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doclist"},[_c('h1',[_vm._v("Dokumente")]),_c('table',_vm._l((_vm.documents),function(doc,i){return _c('tr',{key:'doc-' + i},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'Dokument', params: { id: _vm.atId(doc.id) } }}},[_vm._v(_vm._s(doc.title[0].title))])],1),_c('td',[_vm._v(" "+_vm._s(doc.composer.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }